import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { Row, Col } from "react-bootstrap";
import DatePicker from "react-widgets/DatePicker";
import {
  fetchMasterList,
  fetchMasterListById,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { addTransactionRecord } from "../../../../redux/feature/manufacturing_app/commonTransactionListSlice";
import { toastFunc } from "../../../../components/common/util";
import moment from "moment";
import { fetchTransactionList } from "../../../../redux/feature/manufacturing_app/commonTransactionListSlice";

import JobCardList from "./JobCardList";

const JobCardForm = (props) => {
  const { t } = useTranslation();
  const [validate, setValidate] = useState(false);
  const formRef = useRef(null);
  //const custCodeRef = useRef(null);
  const sizeCodeRef = useRef(null);
  const planTypeRef = useRef(null);
  const requiredDateRef = useRef(null);
  const totalQuantityRef = useRef(null);
  const quantityInNumbersRef = useRef(null);
  const quantityPerJobcardRef = useRef(null);
  // const customerQtyRef = useRef(null);
  // const yieldQtyRef = useRef(null);
  const orderNumberRef = useRef(null);
  let [quantity, setQuantity] = useState();
  let [totalQuantity, setTotalQuantity] = useState(0);
  let [customerQuantity, setCustomerQuantity] = useState();
  let [yieldQuantity, setYieldQuantity] = useState();
  let [orderNumber, setOrderNumber] = useState();

  let [perJobCard, setPerJobCard] = useState(Constants.SETQUANTITYPERJOBCARD);
  const [showJobCardList, setJobCardList] = useState(false);
  const [priority, setPriority] = useState("regular");
  const [siliconize, setSiliconize] = useState(" - ");
  const [custCode, setCustCode] = useState(null);
  const [sizeCode, setSizeCode] = useState(null);
  const [sizeCodeProcess, setSizeCodeProcess] = useState("");
  const [planType, setPlanTypeCode] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [jobcardCode, setjobcardCode] = useState(Date.now());
  const [requiredDate, setRequiredDate] = useState();
  const [remarks, setRemarks] = useState("");
  //   const [sequenceNo, setSequenceNo] = useState("");
  const [toDeptCode, setToDeptCode] = useState();
  const [toDeptName, setToDeptName] = useState();
  const [plan, setPlan] = useState(false);
  const [errors, setErrors] = useState({});
  const [statusConfirmModel, setStatusConfirmModel] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const saveInProgressRef = useRef(false);
  const dispatch = useDispatch();
  let custList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.CUSTOMERS.name]?.data
  );
  useEffect(() => {
    if (!custList) {
      dispatch(fetchMasterList(Constants.MASTER.CUSTOMERS));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [custList]);

  const custResult =
    custList &&
    custList.map(({ customerCode, customerName }) => ({
      customerCode,
      customerName,
    }));

  let sizeList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.SIZE.name]?.data
  );

  useEffect(() => {
    if (!sizeList) {
      dispatch(fetchMasterList(Constants.MASTER.SIZE));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizeList]);

  const sizeResult =
    sizeList &&
    sizeList.map(({ sizeCode, sizeName }) => ({ sizeCode, sizeName }));

  let planTypeList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.PLANTYPE.name]?.data
  );

  useEffect(() => {
    if (!planTypeList) {
      dispatch(fetchMasterList(Constants.MASTER.PLANTYPE));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planTypeList]);

  const planTypeResult =
    planTypeList && planTypeList.map(({ code, name }) => ({ code, name }));

  const getSequenceJobcardNumber = async () => {
    let param = {};
    param.url = "getSequenceListDataById";
    param.page = Constants.MASTER.SEQUENCES.name;
    param.id = "jobcard";
    dispatch(fetchMasterListById(param)).then((result) => {
      //   setSequenceNo(result?.payload?.data[0].sequenceValue);
      generateRowData(result?.payload?.data[0].sequenceValue);
    });
  };

  const { show, onHide } = props;
  let jobCards = [];
  let [rowsData, setRowsData] = useState([]);

  const generateRowData = (sequenceNoData) => {
    // const totalJobRows = quantity / perJobCard
    const fullJobCards = Math.floor(Number(quantity) / perJobCard);
    const totalJobCards = Math.ceil(Number(quantity) / perJobCard);

    const remainingQuantity = Number(quantity) % perJobCard;
    // Add full job cards
    for (let i = 0; i < fullJobCards; i++) {
      jobCards.push({
        jobcardCode: jobcardCode + "_code",
        jobcard: `${sequenceNoData + i + 1}_${totalJobCards}_${i + 1}`,
        batch: sequenceNoData + i + 1,
        customerCode: custCode?.customerCode,
        customerName: custCode?.customerName,
        requiredDate: requiredDate,
        sizeCode: sizeCode?.sizeCode,
        sizeName: sizeCode?.sizeName,
        batchTotalQtyDozen: totalQuantity,
        batchTotalQuantity: Number(quantity),
        plan: plan,
        planType: planType?.name,
        priority,
        siliconize,
        remarks: remarks,
        jobcardStatus: Constants.TRANSACTION_STATUS.OPEN,
        fromDeptCode: "",
        fromDeptName: "",
        toDeptCode: toDeptCode,
        toDeptName: toDeptName,
        slNo: i + 1,
        slCardNo: `${i + 1} / ${totalJobCards}`,
        quantityPerJobCard: perJobCard,
        originalQuantityPerJobCard: perJobCard,
        customerQuantity,
        yieldQuantity,
        orderNumber,
      });
    }
    // Add remaining quantity if it exists
    if (remainingQuantity > 0) {
      jobCards.push({
        jobcardCode: jobcardCode + "_code",
        jobcard: `${sequenceNoData + (fullJobCards + 1)}_${fullJobCards + 1}_${
          fullJobCards + 1
        }`,
        batch: sequenceNoData + fullJobCards + 1,
        customerCode: custCode?.customerCode,
        customerName: custCode?.customerName,
        requiredDate: requiredDate,
        sizeCode: sizeCode?.sizeCode,
        sizeName: sizeCode?.sizeName,
        batchTotalQtyDozen: totalQuantity,
        batchTotalQuantity: quantity,
        plan: plan,
        planType: planType?.name,
        priority,
        siliconize,
        remarks: remarks,
        jobcardStatus: Constants.TRANSACTION_STATUS.OPEN,
        fromDeptCode: "",
        fromDeptName: "",
        toDeptCode: toDeptCode,
        toDeptName: toDeptName,
        slNo: fullJobCards + 1,
        slCardNo: `${fullJobCards + 1} / ${totalJobCards}`,
        quantityPerJobCard: remainingQuantity,
        originalQuantityPerJobCard: remainingQuantity,
        customerQuantity,
        yieldQuantity,
        orderNumber,
      });
    }
    // console.log(">> jobCards", jobCards);
    setRowsData(jobCards);
    setJobCardList(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const generateJobCard = async () => {
    await getSequenceJobcardNumber();
    // This will trigger the rowdata function
  };

  const setFormClear = (e) => {
    // const form = formRef.current;
    setCustCode("");
    setSizeCode("");
    setPlanTypeCode("");
    setPlan(new Date());
    setRequiredDate(new Date());
    setTotalQuantity("");
    setCustomerQuantity("");
    setYieldQuantity("");
    setQuantity();
    setPerJobCard(Constants.SETQUANTITYPERJOBCARD);
    setRowsData("");
    setJobCardList(true);
  };
  const handlePriorityChange = (e) => {
    if (e.target.checked) {
      setPriority("urgent");
    } else {
      setPriority("regular");
    }
  };

  const handleSiliconize = (e) => {
    if (e.target.checked) {
      setSiliconize("siliconize");
    } else {
      setPriority(" - ");
    }
  };

  const errorValidate = () => {
    const newErrors = {};
    if (!custCode)
      newErrors.custCode = t(
        "msg_trasaction.msg_generatejobcard.customerCodeRequired"
      );
    if (!sizeCode)
      newErrors.sizeCode = t(
        "msg_trasaction.msg_generatejobcard.sizeCodeRequired"
      );
    return newErrors;
  };

  const handleGenerate = (event) => {
    const form = formRef.current;
    const newErrors = errorValidate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setValidate(true);
    } else {
      setErrors({});
    }

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      generateJobCard();
    }
  };

  const handleSize = (row) => {
    let param = {};
    param.url = "getProcessListBySize";
    param.page = Constants.MASTER.PROCESS.name;
    param.id = row.sizeCode;
    if (row.sizeCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        if (result?.payload?.data.length > 0) {
          setToDeptCode(result?.payload?.data[0].process[0].deptCode);
          setToDeptName(result?.payload?.data[0].process[0].deptName);
          setSizeCodeProcess("");
        } else {
          setSizeCodeProcess(
            t("msg_trasaction.msg_generatejobcard.sizeProcessNotFound")
          );
        }
      });
    }
  };
  const handleCancel = (event) => {
    props.onHide();
  };
  const handleConfirm = async () => {
    if (saveInProgressRef.current) return;

    if (!Array.isArray(rowsData) || rowsData.length === 0) {
      toastFunc(
        Constants.MASTER.TOAST.error,
        "Generate at least one job card before saving.",
        4000
      );
      return;
    }

    saveInProgressRef.current = true;
    setIsSaving(true);
    const param = {};
    const filteredRows = rowsData.map(({ slNo, slCardNo, ...rest }) => rest);
    param.jobCardData = filteredRows;
    param.method = Constants.TRANSACTION.GENERATEJOBCARD.ADD;
    param.edit = false;
    try {
      const res = await dispatch(addTransactionRecord(param));
      if (res?.payload?.acknowledged) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_trasaction.msg_generatejobcard.success_message"),
          2000
        );
        let param = {};
        param.page = 1;
        param.perPage = Constants.PER_PAGE;
        param.name = Constants.TRANSACTION.GENERATEJOBCARD.name;
        param.method = Constants.TRANSACTION.GENERATEJOBCARD.list;

        dispatch(fetchTransactionList(param)); // userSlice store
        handleCancel(true);
        props.onConfirm(true);
      } else {
        toastFunc(
          Constants.MASTER.TOAST.error,
          res?.payload?.message || "Unable to save the job cards.",
          4000
        );
      }
    } finally {
      saveInProgressRef.current = false;
      setIsSaving(false);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        className="jobcard-modal"
        animation={false}
        backdrop="static"
        size="xl"
      >
        <ModalHeader title={"Add New Job Card"}> </ModalHeader>
        <ModalBody>
          <Container>
            <Form noValidate validated={validate} ref={formRef}>
              <Row className="mb-3">
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridEmail"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t("msg_trasaction.msg_generatejobcard.customer")}
                    </Form.Label>
                    <DropdownListField
                      id="customerCode"
                      name="customerCode"
                      className="dropdownHive w-full rounded-md"
                      data={custResult}
                      onChange={(e) => {
                        setCustCode(e);
                        setErrors({});
                      }}
                      value={custCode}
                      required
                      placeholder={t(
                        "msg_trasaction.msg_generatejobcard.selectCustomer"
                      )}
                      autoFocus={true}
                      error={errors.custCode}
                      // disabled={di sabled}
                    />
                  </Form.Group>
                </Col>
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridEmail"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t("msg_trasaction.msg_generatejobcard.size")}
                    </Form.Label>
                    <DropdownListField
                      id="sizeCode"
                      name="sizeCode"
                      className="dropdownHive w-full rounded-md"
                      data={sizeResult}
                      ref={sizeCodeRef}
                      value={sizeCode}
                      onChange={(e) => {
                        setSizeCode(e);
                        handleSize(e);
                        setErrors({});
                      }}
                      required
                      placeholder={t(
                        "msg_trasaction.msg_generatejobcard.selectSize"
                      )}
                      autoFocus={true}
                      error={errors.sizeCode}
                      // disabled={disabled}
                    />
                    <span className="text-red-500 text-xs">
                      {sizeCodeProcess}
                    </span>
                  </Form.Group>
                </Col>
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridAddress1"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t("msg_trasaction.msg_generatejobcard.plan")}
                    </Form.Label>
                    <DatePicker
                      parse={["MMM yyyy"]}
                      min={new Date()}
                      required
                      onChange={(e) => {
                        setPlan(moment(e).format("YYYY-MM-DD"));
                      }}
                      valueFormat={{ month: "short", year: "numeric" }}
                      calendarProps={{ views: ["year", "decade", "century"] }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridAddress1"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t("msg_trasaction.msg_generatejobcard.planType")}
                    </Form.Label>
                    <DropdownListField
                      id="code"
                      name="name"
                      className="dropdownHive w-full rounded-md"
                      data={planTypeResult}
                      value={planType}
                      onChange={(e) => {
                        setPlanTypeCode(e);
                        setErrors({});
                      }}
                      required
                      placeholder={t(
                        "msg_trasaction.msg_generatejobcard.selectPlanType"
                      )}
                      ref={planTypeRef}
                    />
                  </Form.Group>
                </Col>
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridPassword"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t("msg_trasaction.msg_generatejobcard.requiredDate")}
                    </Form.Label>
                    <DatePicker
                      required
                      min={new Date()}
                      placeholder="m/dd/yy"
                      ref={requiredDateRef}
                      onChange={(e) => {
                        setRequiredDate(moment(e).format("YYYY-MM-DD"));
                        setErrors({});
                      }}
                      autoFocus
                    />
                  </Form.Group>
                </Col>
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridAddress1"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t("msg_trasaction.msg_generatejobcard.orderNumber")}{" "}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      required
                      maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                      name="orderNumber"
                      value={orderNumber}
                      ref={orderNumberRef}
                      onChange={(e) => {
                        setOrderNumber(e.target.value);
                      }}
                      placeholder={t(
                        "msg_trasaction.msg_generatejobcard.orderNumber"
                      )}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {/* <Row>
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridAddress1"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t("msg_trasaction.msg_generatejobcard.customer_qty")}{" "}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      required
                      maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                      name="customerQuantity"
                      onChange={(e) => {
                        e.target.value
                          ? setTotalQuantity(
                              Math.round(
                                (Number(yieldQuantity || 0) +
                                  Number(e.target.value)) /
                                  12
                              )
                            )
                          : setTotalQuantity(0);
                        setQuantity(
                          Number(e.target.value) + Number(yieldQuantity || 0)
                        );
                        setCustomerQuantity(e.target.value);
                      }}
                      // disabled
                      value={customerQuantity}
                      ref={customerQtyRef}
                      placeholder={t(
                        "msg_trasaction.msg_generatejobcard.customer_qty"
                      )}
                    />
                  </Form.Group>
                </Col>
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridAddress2"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t("msg_trasaction.msg_generatejobcard.yield_qty")}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="yieldQuantity"
                      ref={yieldQtyRef}
                      value={yieldQuantity}
                      onChange={(e) => {
                        e.target.value
                          ? setTotalQuantity(
                              Math.round(
                                (Number(customerQuantity) +
                                  Number(e.target.value)) /
                                  12
                              )
                            )
                          : setTotalQuantity(0);
                        setQuantity(
                          Number(customerQuantity) + Number(e.target.value)
                        );
                        setYieldQuantity(e.target.value);
                      }}
                      // disabled
                      placeholder={t(
                        "msg_trasaction.msg_generatejobcard.yield_qty"
                      )}
                    />
                  </Form.Group>
                </Col>
              </Row> */}
              <Row>
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridAddress1"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t(
                        "msg_trasaction.msg_generatejobcard.totalQuantityDozen"
                      )}{" "}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      required
                      maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                      name="totalQuantity"
                      disabled
                      value={totalQuantity || 0}
                      ref={totalQuantityRef}
                    />
                  </Form.Group>
                </Col>
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridAddress2"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t(
                        "msg_trasaction.msg_generatejobcard.totalQuantityinNumbers"
                      )}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="quantityInNumbers"
                      ref={quantityInNumbersRef}
                      value={quantity}
                      // disabled
                      placeholder={t(
                        "msg_trasaction.msg_generatejobcard.totalQuantityinNumbers"
                      )}
                      onChange={(e) => {
                        e.target.value
                          ? setTotalQuantity(
                              Math.round(Number(e.target.value) / 12)
                            )
                          : setTotalQuantity();
                        setQuantity(e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={12} md={4} lg={4}>
                  <Form.Group
                    as={Col}
                    controlId="formGridAddress2"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t(
                        "msg_trasaction.msg_generatejobcard.quantityperJobCard"
                      )}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      required
                      value={perJobCard}
                      name="quantityPerJobCard"
                      maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                      onChange={(e) => setPerJobCard(e.target.value)}
                      ref={quantityPerJobcardRef}
                      placeholder={t(
                        "msg_trasaction.msg_generatejobcard.quantityperJobCard"
                      )}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Form.Group
                  as={Col}
                  id="formGridCheckbox"
                  className="mb-3 px-2"
                >
                  <Form.Check
                    // className="success"
                    inline
                    name="urgent"
                    type="checkbox"
                    label={t("msg_trasaction.msg_generatejobcard.urgent")}
                    onChange={(e) => handlePriorityChange(e)}
                  />
                  <Form.Check
                    // className="success"
                    inline
                    name="siliconize"
                    type="checkbox"
                    label={t("msg_trasaction.msg_generatejobcard.siliconize")}
                    onChange={(e) => handleSiliconize(e)}
                  />
                </Form.Group>
              </Row>
              <Row>
                <Col sm={12} md={12} lg={12}>
                  <Form.Group
                    as={Col}
                    controlId="formGridAddress2"
                    className="mb-3 px-2"
                  >
                    <Form.Label>
                      {t("msg_trasaction.msg_generatejobcard.remarks")}
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      onChange={(e) => setRemarks(e.target.value)}
                      placeholder={t(
                        "msg_trasaction.msg_generatejobcard.remarks"
                      )}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>

            <Row className="mb-3">
              <Col className="text-center">
                {" "}
                {/* Center text in the column */}
                <Button
                  variant="primary"
                  className="me-2"
                  onClick={(e) => handleGenerate(e)}
                >
                  {t("msg_trasaction.msg_generatejobcard.generate")}
                </Button>
                <Button variant="secondary" onClick={(e) => setFormClear(e)}>
                  {t("msg_trasaction.msg_generatejobcard.clear")}
                </Button>
              </Col>
            </Row>
            {showJobCardList && <JobCardList rowsData={rowsData} />}
          </Container>

          {showJobCardList && (
            <Row className="mb-3">
              <Col className="text-center">
                {" "}
                {/* Center text in the column */}
                <Button
                  type="button"
                  variant="success"
                  className="btn btn-success text-center"
                  centered
                  disabled={isSaving}
                  onClick={handleConfirm}
                >
                  {isSaving
                    ? "Saving..."
                    : t("msg_trasaction.msg_generatejobcard.saveconfirm")}
                </Button>
              </Col>
            </Row>
          )}
        </ModalBody>
      </Modal>

      {statusConfirmModel && (
        <ConfirmationModal
          show={statusConfirmModel}
          heading={t("msg_common.confirmation")}
          bodyMessage={t(
            "msg_master_list.msg_department.status_change_message"
          )}
          onOk={() => setStatusConfirmModel(false)}
          onHide={() => setStatusConfirmModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}
    </>
  );
};

export default JobCardForm;
